import { dataAPI } from './dataApi';

export type ActionOperationType = 'increment' | 'decrement' | 'set' | 'clear';

export interface ActionOperation {
    type: ActionOperationType;
    field: string;
    amount?: number;
    value?: string | number | boolean;
}

export interface ActionDefinition {
    uid?: string;
    name: string;
    componentSlug: string;
    operation: ActionOperation;
}

export const actionsAPI = {
    listActions: async () => {
        return await dataAPI.listActions();
    },
    createAction: async (action: ActionDefinition) => {
        return await dataAPI.createAction(action);
    },
    updateAction: async (uid: string, action: ActionDefinition) => {
        return await dataAPI.updateAction(uid, action);
    },
    deleteAction: async (uid: string) => {
        return await dataAPI.deleteAction(uid);
    }
};

export default actionsAPI;
